import { Component, h } from 'preact';
import { createAsyncScriptNode } from '../../../utils/dom';
import { getUserlaneTags } from '../../../selectors/widgetsVisibility';
import { window, document } from '../../../env/browser';

export default class UserlaneWidget extends Component {
  componentDidMount() {
    const { appId, merchant, account } = this.props;
    const userlaneTags = getUserlaneTags(merchant, account);

    window.userlaneSettings = {
      app_id: appId,
      user: {
        id: account.id,
        tags: userlaneTags,
      },
      lang: account.locale,
      configs: {
        assistantPosition: 'left',
      },
    };

    document.head.appendChild(
      createAsyncScriptNode({
        src: '//cdn.userlane.com/userlane.js',
        onload: () => {
          const { analytics, Userlane } = window;

          if (
            typeof analytics !== 'undefined' &&
            typeof analytics.track === 'function' &&
            typeof Userlane === 'function'
          ) {
            const trackUserlaneEvent = (when, what) => {
              Userlane(when, userlaneId => {
                analytics.track(what, {
                  userlaneId,
                });
              });
            };
            trackUserlaneEvent('onStart', 'Userlane started');
            trackUserlaneEvent('onComplete', 'Userlane completed');
            trackUserlaneEvent('onExit', 'Userlane cancelled');
          }
        },
      }),
    );
  }
  render() {
    const { leftOffset = 0, hideUserlaneAssistant } = this.props;
    // Offset's userlane position so it doesn't clash with other page elements
    const positionAssistantCSS = `#userlane-assistant-container {
              bottom: 15px !important;
              left: ${leftOffset}px;
            }`;
    const hideAssistantCSS = `
      #userlane-assistant-container {
        display: none !important;
      }
    `;
    /* eslint-disable react/no-danger */
    return (
      <style
        dangerouslySetInnerHTML={{
          __html: hideUserlaneAssistant
            ? hideAssistantCSS
            : positionAssistantCSS,
        }}
      />
    );
    /* eslint-enable react/no-danger */
  }
}
